import { AdditionalCoverageT, PlanT } from '@csi-monorepo/core/domain/insurance';

const findAdditionalCoverages = (plans: PlanT[]): string[] | undefined => {
  if (!plans || plans?.length === 0) return undefined;

  let additionalAssist: string[] = [];

  plans.forEach((plan: PlanT) => {
    if (
      plan?.additionalAssist &&
      plan?.additionalCoverages &&
      plan?.additionalCoverages?.length > 0
    ) {
      const additional = plan.additionalCoverages.map((value: AdditionalCoverageT) => {
        return value?.name as string;
      });
      additionalAssist = Array.from(new Set([...additionalAssist, ...additional]));
    }
  });

  return additionalAssist;
};

export default findAdditionalCoverages;
